import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {PageViewDeleteRequest} from './contracts'

export async function apiDestroyView(body: PageViewDeleteRequest): Promise<void> {
  const apiData = getApiMetadata('memex-view-delete-api-data')

  const {data} = await fetchJSON<PageViewDeleteRequest, void>(apiData.url, {
    method: 'DELETE',
    body,
    token: apiData.token,
  })

  return data
}
